export const NewFieldName = (): string => `field${Date.now()}`;
